module.exports = __webpack_public_path__ + "static/media/cloud-d2-v3@2x.4016c7b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-d2-v3@2x.png
// module id = 101
// module chunks = 0